/**
 * How the Live tab lays its containers out (user, 20/10/2026: "row by row
 * … or column by column like now"): one row per container, or the cards.
 * The choice is the browser's own (localStorage), rows by default.
 * For Media Devoted | Created By Ciro Autiero
 */
export type LiveLayout = 'rows' | 'cards';

const KEY = 'trafficpulse.automation.live-layout';

export function readLiveLayout(): LiveLayout {
  try {
    return window.localStorage.getItem(KEY) === 'cards' ? 'cards' : 'rows';
  } catch {
    return 'rows';
  }
}

export function writeLiveLayout(layout: LiveLayout): void {
  try {
    window.localStorage.setItem(KEY, layout);
  } catch {
    // a private window or blocked storage: the choice lasts the page
  }
}
